import axios from 'axios';
import store from '../store'
import router from '../router';

export default function setupResponse() {
    axios.interceptors.response.use(function(response) {
        return Promise.resolve(response)
    }, function(err) {
        if (err.response) {
            if (err.response.status == 403) {
                store.dispatch('logout')
                .then(() => router.replace({ name:"landing-page-child" }))
                .catch(err => err)
            }
        }
        return Promise.reject(err) 
    });
}